import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useTRPC } from '@/lib/trpc'

export function usePeople() {
  const trpc = useTRPC()
  return useQuery(trpc.people.list.queryOptions())
}

export function useCreatePerson() {
  const trpc = useTRPC()
  const queryClient = useQueryClient()
  return useMutation(
    trpc.people.create.mutationOptions({
      onSuccess: () => queryClient.invalidateQueries(trpc.people.list.pathFilter())
    })
  )
}

export function useUpdatePerson() {
  const trpc = useTRPC()
  const queryClient = useQueryClient()
  return useMutation(
    trpc.people.update.mutationOptions({
      onSuccess: () => queryClient.invalidateQueries(trpc.people.list.pathFilter())
    })
  )
}
